
import { AnexoProps } from "../comun/AnexoInterface";
import { PaginacionProps } from "../global/PaginacionInterface";

// Definición de defaults

export const defaultConsultaTramitesRecibidos: ConsultaTramitesRecibidosResponse = {
    currentPageIndex:   0,
    pageCount:          0,
    recordsCount:       0,
    records:            [],
}

// Creación de interface

export interface ConsultaTramitesRecibidosParams extends PaginacionProps {
    idTipoTramite:      number;
    idMateria:          number;
    idAutoridad:        number;
    enviadoBuzon:       number;
    fecha:              string;
}

export interface ConsultaTramitesRecibidosResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordsCount:       number;
    records:            ConsultaTramitesRecibidosProps[];
}

export interface ConsultaTramitesRecibidosProps {
    idRecepcion:                number;
    numeroSeguimiento:          string;
    referencia:                 string;
    noReferencia:               string;
    idTipoTramite:              number;
    tipoTramite:                string;
    subTipoTramite:             string;
    usuarioAsignado:            string;
    idEstatus:                  number;
    estatus:                    string;
    folioBuzonElectronico:      string;
    acuse:                      string;
    materia:                    string;
    anexos:                     AnexoProps[];
    fecha?:                     Date;
}

export interface DescargarTramitesRecibidosParams {
    idTipoTramite:      number;
    idMateria:          number;
    idAutoridad:        number;
    enviadoBuzon:       number;
    fecha:              string;    
}